import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/blog/[slug]/page.tsx");
